<template>
  <b-card header="Send New Message" class="m-0">
    <b-card-body class="p-3">
      <div class="row mb-3">
        <div class="col">
          <label class="control-label visible-ie8 visible-ie9" for="recipients">Recipients</label>
          <v-select :class="{'is-invalid': errors.has('recipients')}"
                    v-validate="'required'"
                    data-vv-delay="500"
                    data-vv-as="Recipients"
                    data-vv-name="recipients"
                    type="text"
                    placeholder="Recipients"
                    name="recipients"
                    id="recipients"
                    :options="users"
                    v-model="recipients"/>
          <div class="invalid-tooltip d-block" v-if="errors.has('recipients')">{{ errors.first('recipients') }}</div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <label class="control-label visible-ie8 visible-ie9" for="subject">Subject</label>
          <input
                  :class="{'form-control': true, 'is-invalid': errors.has('subject')}"
                  v-validate="'required|min:5'"
                  data-vv-delay="500"
                  data-vv-as="Subject"
                  data-vv-name="subject"
                  type="text"
                  placeholder="Subject"
                  name="subject"
                  id="subject"
                  v-model="subject"/>
          <div class="invalid-tooltip d-block" v-if="errors.has('subject')">{{ errors.first('subject') }}</div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col">
          <label class="control-label visible-ie8 visible-ie9" for="message">Message</label>
          <vue-editor
                  :class="{'is-invalid': errors.has('message')}"
                  v-validate="'required'"
                  data-vv-delay="500"
                  data-vv-as="Message"
                  data-vv-name="message"
                  type="text"
                  placeholder="Message"
                  name="message"
                  id="message"
                  v-model="message">
          </vue-editor>
          <div class="invalid-tooltip d-block" v-if="errors.has('message')">{{ errors.first('message') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <loading-button block :loading="loading" @submit="sendMessage" :disabled="errors.any()">Send</loading-button>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'CreateMessageModal',
  data () {
    return {
      recipients: {},
      users: [],
      subject: '',
      message: '',
      loading: false
    };
  },
  methods: {
    loadUsers () {
      this.axios.get('messages/recipients').then(rsp => {
        this.users = rsp.data.map(user => {
          return {label: user.name_full + (user.role_name ? ' (' + user.role_name + ')' : ''), value: user};
        });
      });
    },
    sendMessage () {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true;
          let params = {
            subject: this.subject,
            body: this.message,
            recipients: [this.recipients.value]
          };
          this.axios.post('/messages', params).then(() => {
            this.$snotify.success('Message Sent');
            this.reset();
            this.$emit('sent');
            this.$emit('close');
          }).catch(err => {
            this.loading = false;
            this.$snotify.error(err.response.data.message);
          });
        }
      });
    },
    reset () {
      this.recipients = [];
      this.subject = '';
      this.message = '';
      this.loading = false;
    }
  },
  mounted () {
    this.reset();
    this.loadUsers();
  }
};
</script>

<style scoped>

</style>